import * as types from 'actions/types';
import { createReducer, successType } from 'shared/lib/lib/callAPI';

const dataReducer = (state = null, action) => {
  switch (action.type) {
    case successType(types.GET_APPLICANT_STATE):
      return [...action.response];
    case types.LOGOUT:
      return null;
    default:
      return state;
  }
};

export default createReducer(types.GET_APPLICANT_STATE, dataReducer);
